import Message from './message';
export default class TrackSchemaMessage extends Message {
    fire(event, options) {
        this.call({
            event,
            apiMethod: 'trackWithSchema',
        }, options);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2stc2NoZW1hLW1lc3NhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY2RwL21lc3NhZ2VzL3RyYWNrLXNjaGVtYS1tZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sT0FBTyxNQUFNLFdBQVcsQ0FBQztBQUdoQyxNQUFNLENBQUMsT0FBTyxPQUFPLGtCQUFtQixTQUFRLE9BQWdDO0lBQzlFLElBQUksQ0FBQyxLQUFvQixFQUFFLE9BQTBDO1FBQ25FLElBQUksQ0FBQyxJQUFJLENBQ1A7WUFDRSxLQUFLO1lBQ0wsU0FBUyxFQUFFLGlCQUFpQjtTQUM3QixFQUNELE9BQU8sQ0FDUixDQUFDO0lBQ0osQ0FBQztDQUNGIn0=